import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "../components/LeftSocialMediaIconUI";
import { DownloadFileByFileStoreId } from "../components/DownloadFileByFileStoreId";
import { DownloadableFormsDepartments } from "../utils/constants";

const DownloadableForms = () => {
  const { t } = useTranslation();
  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
          <div className="container">
            {/* <div className="section-main-heading2">
               <h4 className="fontSizeClass"> Proceedings of HCC </h4> 
            </div> */}
          </div>
        </div>
      </section>
      <section className="section inner-pad1">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="site-menu">
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    <li className="nav-item">
                      <Link className="nav-link active1 fontSizeClass" to="/DownloadableForms">
                        {t("Download Home")}
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div className="col-lg-9">
              <div className="container">
                <div className="row">
                  <div className="inner-title2 bas">
                    <h3 className="fontSizeClass">
                      {t("All Department Downloads")}
                    </h3>
                  </div>
                  <div className="col-lg-12">
                    <div className="site-menu min-height-400">
                      <nav className="sidebar card py-2">
                        <ul className="nav flex-column" id="nav_accordion">
                          {DownloadableFormsDepartments.map((dept) => {
                            const targetId = `demo-${dept.key}`;
                            return (
                              <li className="nav-item" key={dept.key}>
                                <button
                                  type="button"
                                  className="btn"
                                  data-toggle="collapse"
                                  data-target={`#${targetId}`}
                                  aria-expanded="false"
                                  aria-controls={targetId}
                                >
                                  {t(dept.label)}
                                  <i className="bi bi-chevron-down" />
                                </button>
                                <div id={targetId} className="collapse spac1">
                                  {dept.files.map((file) => (
                                    <DownloadFileByFileStoreId
                                      key={file.fileStoreId + file.label}
                                      fileStoreId={file.fileStoreId}
                                      label={file.label}
                                    />
                                  ))}
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DownloadableForms;
